import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * Body class applied when hiding the static shell from `src/index.html`
 * (`footer.footer` and legacy marketing strips outside `app-root`).
 */
export const TMH_INDEX_SHELL_HIDE_BODY_CLASS = 'tmh-v2-hide-index-header';

/**
 * Toggle index.html chrome from any component (content outside `app-root`).
 * Ref-counted: safe if parent and child both request hide.
 */
@Injectable({
  providedIn: 'root'
})
export class IndexShellChromeService {
  private hideDepth = 0;

  constructor(@Inject(DOCUMENT) private document: Document) {}

  /** Hides index shell chrome. Call once per matching [showIndexShellChrome] (e.g. ngOnInit / ngOnDestroy). */
  hideIndexShellChrome(): void {
    if (this.hideDepth === 0) {
      this.document.body.classList.add(TMH_INDEX_SHELL_HIDE_BODY_CLASS);
    }
    this.hideDepth++;
  }

  /** Releases one [hideIndexShellChrome] request. */
  showIndexShellChrome(): void {
    this.hideDepth = Math.max(0, this.hideDepth - 1);
    if (this.hideDepth === 0) {
      this.document.body.classList.remove(TMH_INDEX_SHELL_HIDE_BODY_CLASS);
    }
  }
}
